import CheckinScanner from "@/pages/CheckinScanner";
export default function GuestCheckin() {
  return <CheckinScanner kind="guest" />;
}
